import { useQuery } from '@tanstack/react-query';
import { userBffQueries } from 'hooks/userBffQueries';
import { isLegacyUserId, resolveLegacyUserId } from 'utils/resolveLegacyUserId';

export function useAssignedUserLegacyId(assignedUser: { id: string | number } | null | undefined, accountId: string | undefined) {
  const numericAccountId = Number(accountId);
  const needsLookup = !!assignedUser && !isLegacyUserId(assignedUser.id) && numericAccountId > 0;

  const { data: users, isLoading } = useQuery({
    ...userBffQueries.accountUsers(numericAccountId),
    enabled: needsLookup,
  });

  return {
    legacyId: assignedUser ? resolveLegacyUserId(assignedUser.id, users) : undefined,
    isResolving: isLoading,
  };
}
